<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img style="height: 40px;" src="img/brand/otc-logo-white.png" alt="logo">
            </router-link>

            <!--<router-link slot="brand" class="navbar-brand mr-lg-5" to="/">-->
                <!--<a href="https://offthecouchgamescom.resova.us/" target="_blank" rel="noopener"-->
                   <!--class="btn btn-neutral btn-icon">-->
                    <!--<span class="btn-inner&#45;&#45;icon">-->
                      <!--<i class="text-default ni ni-controller mr-2"></i>-->
                    <!--</span>-->
                    <!--<span class="text-default"><strong>Book Now</strong></span>-->
                <!--</a>-->
            <!--</router-link>-->


            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
                        <img src="img/brand/otc-logo.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <!--<base-dropdown tag="li" class="nav-item">-->
                    <!--<a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">-->
                        <!--<i class="ni ni-collection d-lg-none"></i>-->
                        <!--<span class="nav-link-inner&#45;&#45;text">Examples</span>-->
                    <!--</a>-->
                    <!--<router-link to="/landing" class="dropdown-item">Landing</router-link>-->
                    <!--<router-link to="/profile" class="dropdown-item">Profile</router-link>-->
                    <!--<router-link to="/login" class="dropdown-item">Login</router-link>-->
                    <!--<router-link to="/register" class="dropdown-item">Register</router-link>-->
                <!--</base-dropdown>-->

                <li class="nav-item">
                    <router-link slot="title" to="/" class="text-white nav-link" role="button">
                        <i class="ni ni-shop d-lg-none"></i> Home
                    </router-link>
                </li>

                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" role="button">
                        <i class="ni ni-controller d-lg-none"></i>
                        Experiences
                    </a>
                    <div class="dropdown-menu-inner">
<!--                        <span class="media d-flex align-items-center">-->
<!--                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">-->
<!--                                <i class="ni ni-atom"></i>-->
<!--                            </div>-->
<!--                            <div class="media-body ml-3">-->
<!--                                <h6 class="heading text-primary mb-md-1">-->
<!--                                    <router-link to="/inheritance">Inheritance</router-link>-->
<!--                                </h6>-->
<!--                                <p class="description d-none d-md-inline-block mb-0">Unlock the secrets left behind by Nikola Tesla to find his hidden fortune and earn the right to claim it.-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </span>-->
                        <span class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-success rounded-circle text-white">
                                <i class="ni ni-key-25"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-success mb-md-1">
                                    <router-link to="/apartment">Occam's Apartment</router-link>
                                </h5>
                                <p class="description d-none d-md-inline-block mb-0">Investigate the disappearance of your friend Detective Occam.</p>
                            </div>
                        </span>
                        <span class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-palette"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">
                                    <router-link to="/gallery">Norcross Art Gallery</router-link>
                                </h5>
                                <p class="description d-none d-md-inline-block mb-0">Explore the Norcross Art Gallery and discover mysteries hidden behind the art.</p>
                            </div>
                        </span>
                        <span class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-default rounded-circle text-white">
                                <i class="ni ni-building"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-default mb-md-1">
                                    <router-link to="/morgue">The Morgue</router-link>
                                </h5>
                                <p class="description d-none d-md-inline-block mb-0">You are forced to go to the Morgue to play a game of life and death with the Evil Genius.</p>
                            </div>
                        </span>
                    </div>
                </base-dropdown>
                <li class="nav-item">
                    <router-link slot="title" to="/pricing" class="text-white nav-link" role="button">
                        <i class="ni ni-collection d-lg-none"></i> Pricing
                    </router-link>
                </li>

                <!--<li class="nav-item">-->
                    <!--<a slot="title" href="/about" class="text-white nav-link" role="button">-->
                        <!--<i class="ni ni-single-02 d-lg-none"></i> About-->
                    <!--</a>-->
                <!--</li>-->

                <base-dropdown class="nav-item" menu-classes="dropdown-menu-lg">
                    <a slot="title" href="#" class="nav-link" role="button">
                        <i class="ni ni-favourite-28 d-lg-none"></i>
                        Learn more
                    </a>
                    <div class="dropdown-menu-inner">
                       <span class="media d-flex align-items-center">
                            <div class="media-body ml-3">
                                <h5 class="heading text-success mb-md-1">
                                    <router-link to="/blog">Blog</router-link>
                                </h5>
                            </div>
                        </span>
                        <span class="media d-flex align-items-center">
                            <div class="media-body ml-3">
                                <h5 class="heading text-success mb-md-1">
                                    <router-link to="/covid">Covid-19 Safety Measures</router-link>
                                </h5>
                            </div>
                        </span>
                        <span class="media d-flex align-items-center">
                            <!--<div class="icon icon-shape bg-gradient-primary rounded-circle text-white">-->
                                <!--<i class="ni ni-atom"></i>-->
                            <!--</div>-->
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">
                                    <router-link to="/faq">FAQ</router-link>
                                </h6>
                                <!--<p class="description d-none d-md-inline-block mb-0">Unlock the secrets left behind by Nikola Tesla to find his hidden fortune and earn the right to claim it.-->
                                <!--</p>-->
                            </div>
                        </span>
                    </div>
                </base-dropdown>
                <li class="nav-item">
                    <router-link slot="title" to="/contact" class="text-white nav-link" role="button">
                        <i class="ni ni-email-83 d-lg-none"></i> Contact Us
                    </router-link>
                </li>

                <!--<li class="nav-item">-->
                    <!--<router-link slot="title" to="/quests" class="nav-link" role="button">-->
                        <!--<i class="ni ni-trophy d-lg-none"></i> Quests-->
                    <!--</router-link>-->
                <!--</li>-->
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <!--<li class="nav-item">-->
                    <!--<a class="nav-link nav-link-icon" href="https://www.facebook.com/offthecouchgames/" target="_blank" rel="noopener"-->
                       <!--data-toggle="tooltip" title="Like us on Facebook">-->
                        <!--<i class="fa fa-facebook-square"></i>-->
                        <!--<span class="nav-link-inner&#45;&#45;text d-lg-none">Facebook</span>-->
                    <!--</a>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                    <!--<a class="nav-link nav-link-icon" href="https://www.instagram.com/offthecouchgames/"-->
                       <!--target="_blank" rel="noopener" data-toggle="tooltip" title="Follow us on Instagram">-->
                        <!--<i class="fa fa-instagram"></i>-->
                        <!--<span class="nav-link-inner&#45;&#45;text d-lg-none">Instagram</span>-->
                    <!--</a>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                    <!--<a class="nav-link nav-link-icon" href="https://twitter.com/otc_games" target="_blank" rel="noopener"-->
                       <!--data-toggle="tooltip" title="Follow us on Twitter">-->
                        <!--<i class="fa fa-twitter-square"></i>-->
                        <!--<span class="nav-link-inner&#45;&#45;text d-lg-none">Twitter</span>-->
                    <!--</a>-->
                <!--</li>-->
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="https://offthecouch.io/checkin/otc"
                       v-on:click="tracker('Waiver', 'Redirected to waiver', 'Waiver button on Nav bar')"
                       target="_blank" rel="noopener"
                       class="btn btn-success">
                        <span class="nav-link-inner--text"><strong>Sign Waiver</strong></span>
                    </a>
                </li>

                <li class="nav-item mt-3 d-lg-none">
                    <a href="https://offthecouch.io/checkin/otc"
                       v-on:click="tracker('Waiver', 'Redirected to waiver', 'Waiver button on Nav bar - small screen')"
                       target="_blank" rel="noopener"
                       class="btn btn-primary">
                        <span class="nav-link-inner--text"><strong>Sign Waiver</strong></span>
                    </a>
                    <a href="https://offthecouch.io/book/otc"
                       v-on:click="tracker('Booking', 'Redirected to booking', 'Booking button on Nav bar - small screen')"
                       target="_blank" rel="noopener"
                       class="btn btn-primary btn-icon">
                        <span class="btn-inner--icon">
                          <i class="ni ni-controller mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text"><strong>Book Now</strong></span>
                    </a>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="https://offthecouch.io/book/otc"
                       v-on:click="tracker('Booking', 'Redirected to booking', 'Booking button on Nav bar')"
                       target="_blank" rel="noopener"
                       class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                          <i class="text-default ni ni-controller mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text text-default"><strong>Book Now</strong></span>
                    </a>
                </li>

            </ul>
        </base-nav>
    </header>
</template>
<script>
    import BaseNav from "@/components/BaseNav";
    import BaseDropdown from "@/components/BaseDropdown";
    import CloseButton from "@/components/CloseButton";

    export default {
        components: {
            BaseNav,
            CloseButton,
            BaseDropdown
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    };
</script>
<style>
    .text-quest {
        color: #65ffbd;
    }
</style>
